import { FC } from 'react';

import ServingSizeListing from 'components/main/ServingSize';

const ServingSize: FC = () => <ServingSizeListing />;

export default ServingSize;
